var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-7.5 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "six"), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.938l-5.844 9.125c0.438-0.063 0.875-0.125 1.313-0.125 3.906 0 7.094 3.188 7.094 7.094 0 3.938-3.188 7.094-7.094 7.094-3.313 0-6.125-2.281-6.906-5.344-0.156-0.531-0.219-1.156-0.219-1.75 0-1.344 0.406-2.594 1.031-3.656l0.188-0.313 8.5-13.344zM4.906 15.969l-0.594 0.875c-0.313 0.688-0.5 1.406-0.5 2.188 0 2.688 2.219 4.906 4.906 4.906s4.844-2.219 4.844-4.906-2.156-4.875-4.844-4.875c-1.531 0-2.906 0.719-3.813 1.813z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.bdcd92bfc12bd0a0e435715ddc0d5ecd.svg";
export { ForwardRef as ReactComponent };